export const scrollToSection = (className, offset = 50) => {
    window.scrollTo({
        top: document?.querySelector(`.${className}`)?.getBoundingClientRect().top + window.scrollY - offset,
        behavior: 'smooth',
    });
};

export const with404Page = async (request, navigate) => {
    const { error } = await request;
    if (error?.message === 'Request failed with status code 404') {
        navigate('/404');
    }
};
